import { isTextEmpty } from '~/_shared/utils/text/text.helpers';
import { validateEmail } from '~/_shared/utils/throttle/validation/validation.helpers';
import { type UserRegisterData } from './useUserRegister';

export const validateRegisterForm = (data: UserRegisterData): boolean => {
  return !isTextEmpty(data.firstName) && !isTextEmpty(data.lastName) && validateEmail(data.email) && !isTextEmpty(data.password);
};
